import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import * as _ from 'lodash';

import { AuthenticationService } from '../../../../../services';
import { Customer } from '../models/customer';
import { HttpService } from '../../../../../services/http.service';
import { Constants } from '../../../../../app.constant';
import { FileUploader } from "ng2-file-upload";
@Injectable()
export class CustomerService extends HttpService {
  public customer: Customer;
  public editdata: Customer = <Customer>{};
  protected URL = Constants.Var.BASE_URL + "/customer/branding/image";
  public customerInsertedId;
  public customerBrandingDetails:any;

  getCustomers(): Observable<Customer[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/customer', requestOptionsArgs, 'customer')
      .map(res => <Customer[]>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }  
  
  getCustomerBrandingDetails(customerId): Observable<any> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/customer/branding/'+customerId, requestOptionsArgs, 'customer')
      .map(res => <Customer[]>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  validateEmail(email): Observable<Customer[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/point-of-contact?email='+encodeURIComponent(email), requestOptionsArgs, 'validate-email')
      .map(res => <Customer[]>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getDevice(): Observable<Customer[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/device', requestOptionsArgs, 'device')
      .map(res => <Customer[]>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  addCustomer(customer: object): Observable<boolean> {
    customer = _.assignIn({}, customer);

    let requestOptionsArgs = { body: customer };
    return this.postApi('/customer', requestOptionsArgs, 'customer')
      .map(res => {

        // login successful if there's a jwt token in the response
        //let token = res.json() && res.json().token;

        let customer = <Customer>res.json() && res.json().customer;
        // set token property
        this.customer = customer;
        return <Customer>res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  editCustomer(customerId: string, customer: object): Observable<boolean> {
    customer = _.assignIn({}, customer);
    let requestOptionsArgs = { body: customer };
    return this.putApi('/customer/' + customerId, requestOptionsArgs, 'customer')
      .map(res => {

        // login successful if there's a jwt token in the response
        //let token = res.json() && res.json().token;

        let customer = <Customer>res.json() && res.json().customer;
        // set token property
        this.customer = customer;

        // return true to indicate successful login
        return <Customer>res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  updateStatus(param): Observable<boolean> {

    let requestOptionsArgs = { body: param };
    return this.putApi('/customer', requestOptionsArgs, 'customer')
      .map(res => {

        // login successful if there's a jwt token in the response
        //let token = res.json() && res.json().token;

        let customer = <Customer>res.json() && res.json().customer;
        // set token property
        this.customer = customer;

        // return true to indicate successful login
        return <Customer>res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  addPOC(customer_id: string, customer: object): Observable<boolean> {
    customer = _.assignIn({}, customer);
    let param={
      "append-customer-created-error": true
    }
    let requestOptionsArgs = { body: customer };
    return this.postApi('/point-of-contact/' + customer_id+'?append-customer-created-error=true', requestOptionsArgs, 'poc')
      .map(res => {
        // login successful if there's a jwt token in the response
        //let token = res.json() && res.json().token;
        this.syncOrganizationData(customer_id, res.json().result.userId).subscribe(result => {}, err => {});
        let customer = <Customer>res.json() && res.json().customer;
        // set token property
        this.customer = customer;

        // return true to indicate successful login
        return <Customer>res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }


  syncOrganizationData(customerId: string, userId: number) {
    let requestOptionsArgs = {};
    return this.getApi('/qms/sync-organization-details?customerId='+customerId+'&userId='+userId, requestOptionsArgs, '', false );
  }

  updatePOC(customer_id: string, customer: object): Observable<boolean> {
    customer = _.assignIn({}, customer);
    let requestOptionsArgs = { body: customer };
    return this.postApi('/point-of-contact/' + customer_id, requestOptionsArgs, 'poc')
      .map(res => {
        this.updateAndSyncOrganizationData(customer_id, res.json().result.userId).subscribe(result => {}, err => {});
        // login successful if there's a jwt token in the response
        //let token = res.json() && res.json().token;

        let customer = <Customer>res.json() && res.json().customer;
        // set token property
        this.customer = customer;

        // return true to indicate successful login
        return <Customer>res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  updateAndSyncOrganizationData(customerId: string, userId: number) {
    let requestOptionsArgs = {};
    return this.getApi('/qms/sync-update-organization-details?customerId='+customerId+'&userId='+userId, requestOptionsArgs, '', false);
  }

  resetEditCustomer() {
    this.editdata = <Customer>{};
  }

  deleteCustomer(param): Observable<boolean> {

    let requestOptionsArgs = { body:  param  };
    return this.deleteApi('/customer', requestOptionsArgs, 'deleteCustomer')
      .map(res => {
        return true;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  migrateDeviceData(customerId: string) {
    let requestOptionsArgs = {};
    return this.getApi('/app-upgrade/notifyToMigratedDevicesOnly?customerId=' + customerId, requestOptionsArgs, '', false)
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  
  getCustomersByAdvanceSearch(searchParam): Observable<Customer[]> {
    const optionals = Constants.setParamsObject(searchParam);
    let searchQuery:any;
    let query=optionals.split('=')
    if(query[1]!='%7B%7D') {
      searchQuery=optionals;
    } else {
      searchQuery='';
    }
    let requestOptionsArgs = {};
    return this.getApi('/customer'+searchQuery, requestOptionsArgs, 'customer')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  getPhoneCodes(): Observable<any> {
    // get country codes
    let requestOptionsArgs = {};
    return this.getApi('/country-codes', requestOptionsArgs, 'contact-country-code')
      .map(res => res.json() && res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getResetPwdEmail(userEmail:string, customerID: number): Observable<any> {
    // get poc-can-send-email
    let token = Constants.userAuthorisedToken();
    let customerId = customerID;
    //let requestOptionsArgs:any = {search: { 'email': encodeURIComponent(userEmail) }}
    let requestOptionsArgs:any = {}
    requestOptionsArgs.headers = {}
    requestOptionsArgs.headers['Authorization'] = `Bearer ${token}`;
    requestOptionsArgs.headers['customerId'] = customerId;
    return this.getApi('/poc-can-send-email?email='+encodeURIComponent(userEmail), requestOptionsArgs, '/poc-can-send-email')
      .map(res => res.json() && res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  public sendEmailToResetPwd(email: string): Observable<boolean> {
    const requestOptionsArgs = { body: { 'email': email } };
    return this.postApi('/password-forgot?email-type=resend-set-password', requestOptionsArgs, 'password-forgot')
      .map(res => {
        const resMsg = res.json();
        return resMsg;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  validatePocMobile(pocObj:any, customerID: number): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/point-of-contact?mobile-number='+encodeURIComponent(pocObj.mobile)+'&country-code='+encodeURIComponent(pocObj.code), requestOptionsArgs, 'validate-email')
      .map(res => <Customer[]>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }  

  fileUpload(authToken,customerId?) {
    if(customerId != undefined){
      let res: FileUploader;
      res = new FileUploader({
      url: this.URL+'/'+customerId,
      method:'PUT',
      authToken: authToken,
      disableMultipart: true,
      formatDataFunctionIsAsync: false,
      formatDataFunction: async (item) => {
        return new Promise((resolve, reject) => {
          resolve({
            name: item._file.name,
            length: item._file.size,
            contentType: item._file.type,
            date: new Date()
          });
        });
      }
    });
      return res;
  }
  }
  uploadFile(data: FormData, customerId:number, uploadImgFor:string): Observable<any> {
    let token = Constants.userAuthorisedToken();
    let requestOptionsArgs: any = {}
    requestOptionsArgs.headers = {}
    requestOptionsArgs.headers['Authorization'] = `Bearer ${token}`;
    requestOptionsArgs.headers['customerId'] = customerId;
    return this.http.post(this.URL+'/'+customerId,data,requestOptionsArgs)
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  
  postCustomerDetails(values, customerId:number): Observable<String> {
    // let token = Constants.userAuthorisedToken();
    let requestOptionsArgs: any,_apiPath
    if(values.host){
      requestOptionsArgs = {body:{'smtp': values}}
    }
    else{      
      requestOptionsArgs = {body:values}
    }
    console.log("requestOptionsArgs ==>", requestOptionsArgs)
    if(values.adPlatformBrandUrl)
      _apiPath = this.postApi('/customer/branding/text/sdn/'+customerId, requestOptionsArgs, 'customer-branding-text', false)
    else
      _apiPath = this.postApi('/customer/branding/text/'+customerId, requestOptionsArgs, 'customer-branding-text', false)
    
    
      return _apiPath
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  
  testSmtpMails(values, customerId:number): Observable<String> {
    let requestOptionsArgs: any    
    requestOptionsArgs = {body:values}
    console.log("requestOptionsArgs ==>", requestOptionsArgs)
    return this.postApi('/customer/branding/email/test', requestOptionsArgs, 'customer-branding-text', false)
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  

  removeImg(param, customerId): Observable<boolean> {
    let requestOptionsArgs = { body:  param };
    return this.deleteApi('/customer/branding/image/'+customerId, requestOptionsArgs, 'delete-customer-img', false)
      .map(res => res.json() && res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  
  
  // self-registration [POST]
  selfRegistration(customer: object): Observable<boolean> {
    customer = _.assignIn({}, customer);

    let requestOptionsArgs = { body: customer };
    return this.postApi('/customer/self-registration', requestOptionsArgs, 'customer')
      .map(res => {

        let customer = <Customer>res.json() && res.json().customer;
        // set token property
        this.customer = customer;
        return <Customer>res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  
  editSelfRegistration(customerId:string,customer: object): Observable<boolean> {
    customer = _.assignIn({}, customer);

    let requestOptionsArgs = { body: customer };
    return this.putApi('/customer/self-registration/'+customerId, requestOptionsArgs, 'customer')
      .map(res => {
        let customer = <Customer>res.json() && res.json().customer;
        // set token property
        this.customer = customer;
        return <Customer>res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  
  getCustomersForApproval(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/customer/self-registration', requestOptionsArgs, 'customerSelfRegistered', false)
      .map(res => res.json() && res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCustomerBrandingDetailsAfterImpersonate(customerId): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/customer/branding/'+customerId, requestOptionsArgs, 'customerSelfRegistered', false)
      .map(res => res.json() && res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  appUpgradeDownload(os): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/app-upgrade/angular/download?os='+os, requestOptionsArgs, 'customerSelfRegistered', false)
      .map(res => res.json() && res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/components/customers/services/customer.service.ts